import { createCachedSelector } from "re-reselect";

import { selectV2UserAccessibleScope } from "store/slices/apisV2/control-flow/control-flow-scope-selectors";
import type { ApiScope } from "utils/dataTree/scope";

export const selectUserAccessibleScopeForApiUnion = createCachedSelector(
  selectV2UserAccessibleScope,
  (v2Scope: ApiScope | undefined) => v2Scope,
)(
  (state, apiId: string | undefined, actionId: string | undefined) =>
    `${apiId}_${actionId}`,
);
